module.exports = "<p>\n  email-smtp works!\n</p>\n"